import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-bfb8fe5e"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "articleList" };
const _hoisted_2 = { class: "list" };
const _hoisted_3 = ["onClick"];
const _hoisted_4 = { class: "info flex-1 m-r24" };
const _hoisted_5 = { class: "title font-32 font-w500" };
const _hoisted_6 = { class: "desc font-28 text-overflow" };
const _hoisted_7 = { class: "views font-24 gray-9" };
const _hoisted_8 = { class: "imgBox" };
const _hoisted_9 = { alt: "" };
import { hostPath } from '@/public/utils/basePath';
import { appPort, jumpModuleApp } from '@/widget';
export default /*#__PURE__*/ _defineComponent({
    props: {
        list: {
            default: [],
            type: Array
        }
    },
    emits: ['toRecommend'],
    setup(__props, { emit: emits }) {
        const props = __props;
        const toDetail = (item) => {
            let id = item.articleId || item.id;
            let url = `${hostPath}/news/detail?id=${id}`;
            emits('toRecommend', { recommendType: 'article' });
            if (appPort()) {
                let data = {
                    dataId: id,
                    typeId: 'article_detail',
                    url: url
                };
                jumpModuleApp(data);
            }
            else {
                location.assign(url);
            }
        };
        return (_ctx, _cache) => {
            const _directive_lazy = _resolveDirective("lazy");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("ul", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.list, (item) => {
                        return (_openBlock(), _createElementBlock("li", {
                            class: "flex-between m-b32 p-b24 ig-border-b1",
                            onClick: _withModifiers(($event) => (toDetail(item)), ["stop"]),
                            key: item.articleId || item.id
                        }, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, _toDisplayString(item.title), 1),
                                _createElementVNode("div", _hoisted_6, _toDisplayString(item.desc), 1),
                                _createElementVNode("div", _hoisted_7, _toDisplayString(item.pubDate + ' ' + item.viewCountText), 1)
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                                _withDirectives(_createElementVNode("img", _hoisted_9, null, 512), [
                                    [_directive_lazy, item.img || item.image]
                                ])
                            ])
                        ], 8, _hoisted_3));
                    }), 128))
                ])
            ]));
        };
    }
});
